import React, {useEffect, useState} from 'react';

// A session restored moments later should not flash a warning above the home page.
export default function AuthRecoveryNotice({message}) {
  const [visibleMessage, setVisibleMessage] = useState('');
  useEffect(() => {
    setVisibleMessage('');
    if (!message) return;
    const timer = setTimeout(() => setVisibleMessage(message), 5000);
    return () => clearTimeout(timer);
  }, [message]);
  if (!message || visibleMessage !== message) return null;
  return <div role="status" style={{background:'#fff8e1',color:'#695723',padding:'10px 16px',fontSize:14,lineHeight:1.5}}>
    No pudimos recuperar tu sesión. Revisa tu conexión; si continúa, vuelve a iniciar sesión.
  </div>;
}
